const state = {
    modalMessage: {},
    imagePath: ""
}



const mutations = {
   START_NEW_MODAL_MESSAGE(state, payload) {
        state.modalMessage = payload;
        state.modalMessage.isShow = true;

   },
   CLOSE_MODAL_MESSAGE(state) {
    state.modalMessage.isShow = false;
    state.modalMessage.topic = "";
    state.modalMessage.info = "";
    state.modalMessage.event = null
   },
   UPDATE_IMAGE_PATH(state, payload) {
        state.imagePath = payload
   }
};

const actions = {
    newModalMessage({commit}, payload) {
        commit('START_NEW_MODAL_MESSAGE', payload)
    },
    closeModalMessage({commit}) {
        commit('CLOSE_MODAL_MESSAGE')
    },
    findImagePath({commit}) {
        if(process.env.NODE_ENV == "development") {
            commit('UPDATE_IMAGE_PATH', '/images/')
        } else {
            commit('UPDATE_IMAGE_PATH', '/files/dali-linienplaner/images/')
        }
    }
};

const getters = {
    getModalMessage: state => state.modalMessage,
    getImagePath: state => state.imagePath
};

const namespaced = true;

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced
};
